import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { MentorAbsenceViewModel } from "../MentorAbsenceViewModel";
import { APIManager } from "./APIManager";
import { CommandsManager } from "./CommandsManager";
import { DomainManager } from "./DomainManager";
import { MobXManager } from "./MobXManager";

export class ManagersModule extends ManagersModuleBase<MentorAbsenceViewModel> {
    public api!: APIManager;
    public commands!: CommandsManager;
    public domain!: DomainManager;
    public mobx!: MobXManager;

    constructor(viewModel: MentorAbsenceViewModel) {
        super(viewModel);
        this.createManagers();
    }

    protected createManagers(): void {
        this.mobx = new MobXManager(this.viewModel);
        this.api = new APIManager(this.viewModel);
        this.domain = new DomainManager(this.viewModel);
        this.commands = new CommandsManager(this.viewModel);
    }
}
